import { keyframes, css } from '@emotion/react';

const loadingFlash = keyframes`
  0% {
    background-position: -10px;
  }
  100% {
    background-position: calc(100% + 250px);
  }
`;

const skeletonStyles = css({
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(241, 242, 244, 1)',
  borderRadius: '4px',
  position: 'relative',

  '&::before': {
    content: '""',
    display: 'block',
    width: '100%',
    height: '100%',
    borderRadius: '4px',
    background: `linear-gradient(
      90deg,
      rgba(241, 242, 244, 1) 0,
      #f9f9f9 calc(50% - 25px),
      #f9f9f9 calc(50% + 25px),
      rgba(241, 242, 244, 1) 100%
    )`,

    backgroundSize: '35%',
    backgroundPosition: 0,
    backgroundRepeat: 'no-repeat',
    animation: `${loadingFlash} 2.5s infinite linear`,
  },
});

export const SkeletonLoader: React.FC = () => <div css={skeletonStyles} data-testid="skeleton-loader" />;
